
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
/**
- This datepicker is based on library vuejs-datepicker, you can pass any its exact props to this component
- If want to change input text color, modify <b> .eu-datepicker-container .vdp-datepicker input </b>
**/
export default Vue.extend<any, any, any, any>({
  name: 'ModalDatePicker',
  components: {
    Datepicker
  },
  props: {
    /*
     * Set value on datepicker
     */
    value: {
      type: [String, Date],
      default: () => new Date()
    },
    /*
     * Set id on datepicker
     */
    id: {
      type: String,
      default: ''
    },
    /*
     * Set placeholder
     */
    placeholder: {
      type: String,
      default: 'Input date here'
    },
    /*
     * Set input on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set input on success state
     */
    success: {
      type: Boolean,
      default: false
    },
    /**
     * Set disabled dates.\n
     * Read more: https://www.npmjs.com/package/vuejs-datepicker#disabled-dates
     */
    disabledDate: {
      type: Object,
      default: () => {}
    },
    /**
     * Set date format
     */
    dateFormat: {
      type: [String, Function],
      default: 'dd MMM yyyy'
    },
    /**
     * Set title label
     */
    titleLabel: {
      type: String,
      default: 'Select Date'
    }
  },
  data() {
    return {
      date: new Date(),
      isSelected: false,
      active: false,
      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    };
  },
  computed: {
    containerClasses() {
      return {
        active: this.active,
        error: this.error,
        success: this.success,
        disabled: this.$attrs.disabled === true
      };
    },
    selectedLabel() {
      this.date = this.value;
      let date = new Date();
      let label = '';
      if (this.date) {
        date = new Date(this.date);
      }
      label = `${this.dayNames[date.getDay()]}, ${date.getDate()} ${
        this.monthNames[date.getMonth()]
      } ${date.getFullYear()}`;
      this.$forceUpdate();
      return label;
    },
    focusDateValue() {
      if (this.value === '' && this.disabledDate && this.disabledDate.from) {
        return this.disabledDate.from;
      }
      if (typeof this.value === 'string' && this.value !== '') {
        return new Date(this.value);
      }
      return this.value ? this.value : undefined;
    }
  },
  methods: {
    handleInput(e: Event) {
      /**
       * Input date value
       * @event input
       * @type {function}
       */
      this.$emit('input', e);
    },
    handleSelected(e: Event) {
      this.closeModal();
      this.isSelected = true;
      /**
       * When a date is selected
       * @event selected
       * @type {function}
       */
      this.$emit('selected', e);
    },
    closeModal(e: Event) {
      this.active = false;
      this.$forceUpdate();
    },
    openModal(e: Event) {
      if (!this.$attrs.disabled) {
        if (this.isSelected) {
          this.isSelected = false;
          return;
        }
        this.active = true;
        this.$forceUpdate();
      }
    }
  }
});
